exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*[data-v-06385f5b]{margin:0;padding:0}#app[data-v-06385f5b],.app-container[data-v-06385f5b],body[data-v-06385f5b],html[data-v-06385f5b]{width:100%;height:100%}.app-container[data-v-06385f5b]{position:relative}", ""]);

// exports
